// extracted by mini-css-extract-plugin
export default {"cta":"oH-z","disabled":"pH-z"};